// sessionStreams.js — the streams and session reads a page with no session
// never opens (persona audit round 1, OV-2).
//
// MEASURED (dev, 2026-10-24/25, all eight personas): a signed-out page
// (/signup, /login, /demo, the magic-link callback before its tokens land)
// opened the shell's meet stream — `GET /core/meet/stream` answered 401 six to
// eighteen times while the SDK retried — and read the persona oracle
// (`GET /workspace-project/persona` → 401). The first signed-in load opened
// the same stream before the workspace was known (400: no workspace in the
// scope). Both are a SESSION's reads: the shell's meet channel feeds the call
// badge of ONE workspace, and the persona oracle reports the session's own
// role lens. Without a session there is nothing to stream and nothing to ask.
//
// The session signal is `currentUserEmail` — the one the shell's other
// realtime streams already wait on (app.js `_ensureShellRealtime`).
//
// FRANK: each export is self-contained (FA204) — no module-scope helper.

// The workspace id the shell's meet channel may open for, or null (no
// session yet, or no workspace resolved yet).
export function meetRealtimeScope(root) {
  const r = root && typeof root === 'object' ? root : null
  if (!r || typeof r.currentUserEmail !== 'string' || !r.currentUserEmail) return null
  const ws = r.workspace && typeof r.workspace === 'object' ? r.workspace : null
  const id = ws && (ws.id || ws._id)
  return id ? String(id) : null
}

// May the persona oracle (GET /persona) ask now? Only with a session AND its
// workspace: the worker authenticates /persona against the session's active
// workspace like every route, so a signed-in session with none is answered 401
// "no active workspace for user" (staging 2026-10-31: a new member's first
// boot, on the invite page before the accept writes the org), and a persona
// lens is bound to a workspace anyway. The signed-in boot asks once its
// workspace lands (loadPrivateData, through this gate), so a mount that skips
// it loses nothing.
export function personaOracleReady(root) {
  const r = root && typeof root === 'object' ? root : null
  if (!r || r.signedIn !== true) return false
  if (typeof r.currentUserEmail !== 'string' || !r.currentUserEmail) return false
  const ws = r.workspace && typeof r.workspace === 'object' ? r.workspace : null
  return !!(ws && (ws.id || ws._id))
}
